import React, { Component } from "react";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import "./App.scss";
import Header from "./components/Header";
import Footer from "./components/Footer";
import About from "./components/About";
import Experience from "./components/Experience";
import Projects from "./components/Projects";
import Skills from "./components/Skills";
import FloatingAICompanion from "./components/FloatingAICompanion";
import Beyond from "./components/Beyond";

// Import the JSON files directly from src
import sharedData from "./portfolio_shared_data.json";
import primaryLanguageData from "./res_primaryLanguage.json";
import secondaryLanguageData from "./res_secondaryLanguage.json";
import swedishLanguageData from "./res_swedish.json";
import finnishLanguageData from "./res_finnish.json";

class App extends Component {
  constructor(props) {
    super();
    this.state = {
      resumeData: primaryLanguageData,
      sharedData: sharedData,
      showNotification: false,
      languageName: ''
    };
    this.notificationTimeout = null;
  }

  showLanguageNotification(languageName) {
    // Clear any existing timeout
    if (this.notificationTimeout) {
      clearTimeout(this.notificationTimeout);
    }
    
    // Show notification
    this.setState({ 
      showNotification: true, 
      languageName: languageName 
    });
    
    // Hide after 4 seconds
    this.notificationTimeout = setTimeout(() => {
      this.setState({ showNotification: false });
    }, 4000);
  }

  applyPickedLanguage(pickedLanguage, langIconId) {
    this.swapCurrentlyActiveLanguage(langIconId);
    document.documentElement.lang = pickedLanguage;
    
    // Use the imported JSON directly based on selected language
    let data;
    if (pickedLanguage === window.$primaryLanguage) {
      data = primaryLanguageData;
    } else if (pickedLanguage === window.$secondaryLanguage) {
      data = secondaryLanguageData;
    } else if (pickedLanguage === window.$swedishLanguage) {
      data = swedishLanguageData;
    } else if (pickedLanguage === window.$finnishLanguage) {
      data = finnishLanguageData;
    } else {
      data = primaryLanguageData;
    }
    
    // Update shared data with language-specific name and titles
    const updatedSharedData = {
      ...this.state.sharedData,
      basic_info: {
        ...this.state.sharedData.basic_info,
        name: data.basic_info.name,
        titles: data.basic_info.titles
      }
    };
    
    this.setState({ 
      resumeData: data,
      sharedData: updatedSharedData
    });
    
    // Show notification
    this.showLanguageNotification(data.basic_info.language_name);
  }

  swapCurrentlyActiveLanguage(clickedLangIconId) {
    // Remove brightness filter from all language icons
    const iconIds = [
      window.$primaryLanguageIconId,
      window.$secondaryLanguageIconId,
      window.$swedishLanguageIconId,
      window.$finnishLanguageIconId
    ];
    
    iconIds.forEach(iconId => {
      const element = document.getElementById(iconId);
      if (element) {
        element.removeAttribute("filter");
      }
    });
    
    // Apply brightness filter to clicked icon
    const clickedElement = document.getElementById(clickedLangIconId);
    if (clickedElement) {
      clickedElement.setAttribute("filter", "brightness(40%)");
    }
  }

  componentDidMount() {
    // Set document title
    document.title = `${this.state.sharedData.basic_info.name}`;
    
    this.applyPickedLanguage(
      window.$primaryLanguage,
      window.$primaryLanguageIconId
    );
  }

  componentWillUnmount() {
    // Clean up timeout
    if (this.notificationTimeout) {
      clearTimeout(this.notificationTimeout);
    }
  }

  renderHome = () => {
    return (
      <div>
        <Header sharedData={this.state.sharedData.basic_info} />
        <div className="col-md-12 mx-auto text-center language">
          <div
            onClick={() =>
              this.applyPickedLanguage(
                window.$primaryLanguage,
                window.$primaryLanguageIconId
              )
            }
            style={{ display: "inline", cursor: "pointer" }}
          >
            <span
              className="iconify language-icon mr-5"
              data-icon="twemoji-flag-for-flag-united-kingdom"
              data-inline="false"
              id={window.$primaryLanguageIconId}
            ></span>
          </div>
          <div
            onClick={() =>
              this.applyPickedLanguage(
                window.$secondaryLanguage,
                window.$secondaryLanguageIconId
              )
            }
            style={{ display: "inline", cursor: "pointer" }}
          >
            <span
              className="iconify language-icon mr-5"
              data-icon="twemoji-flag-for-flag-india"
              data-inline="false"
              id={window.$secondaryLanguageIconId}
            ></span>
          </div>
          <div
            onClick={() =>
              this.applyPickedLanguage(
                window.$swedishLanguage,
                window.$swedishLanguageIconId
              )
            }
            style={{ display: "inline", cursor: "pointer" }}
          >
            <span
              className="iconify language-icon mr-5"
              data-icon="twemoji-flag-for-flag-sweden"
              data-inline="false"
              id={window.$swedishLanguageIconId}
            ></span>
          </div>
          <div
            onClick={() =>
              this.applyPickedLanguage(
                window.$finnishLanguage,
                window.$finnishLanguageIconId
              )
            }
            style={{ display: "inline", cursor: "pointer" }}
          >
            <span
              className="iconify language-icon"
              data-icon="twemoji-flag-for-flag-finland"
              data-inline="false"
              id={window.$finnishLanguageIconId}
            ></span>
          </div>
        </div>
        <About
          resumeBasicInfo={this.state.resumeData.basic_info}
          sharedBasicInfo={this.state.sharedData.basic_info}
        />
        <Projects
          resumeProjects={this.state.resumeData.projects}
          resumeBasicInfo={this.state.resumeData.basic_info}
        />
        <Skills
          sharedSkills={this.state.sharedData.skills}
          resumeBasicInfo={this.state.resumeData.basic_info}
        />
        <Experience
          resumeExperience={this.state.resumeData.experience}
          resumeBasicInfo={this.state.resumeData.basic_info}
        />
        <Footer sharedBasicInfo={this.state.sharedData.basic_info} />
      </div>
    );
  };

  render() {
    return (
      <Router>
        <div>
          <Switch>
            <Route exact path="/" render={this.renderHome} />
            <Route path="/beyond" render={() => <Beyond sharedBasicInfo={this.state.sharedData.basic_info} beyondData={this.state.resumeData.beyond} />} />
          </Switch>
          {/* Add the FloatingAICompanion component */}
          <FloatingAICompanion />
          {/* Language Change Notification */}
          <div className={`language-notification ${this.state.showNotification ? 'show' : 'hide'}`}>
            Language changed to {this.state.languageName}
          </div>
        </div>
      </Router>
    );
  }
}

export default App;